export default {
	"menu.dashboard": "My Dashboard",
	"menu.product-catalogue": "Product Catalogue",
	"menu.menu-management": "Menu Management",
	"menu.menu-quick-edit": "Menu Quick Editor",
	"menu.menu-management.menu-management": "Menu Management",
	"menu.menu-management.menu-item": "Menu Item",
	"menu.menu-management.menu-reorder": "Reorder Menu",
	"menu.menu-management.options-reorder": "Reorder Options",
	"menu.menu-management.menu-quick-edit": "Menu Quick Editor",
	"menu.menu-management.pos-preview": "POS Preview",
	"menu.menu-management.menu-status": "Menu Status",
	"menu.menu-management.menu-bulk-edit": "Menu Bulk Edit",
	"menu.promotions": "Promotions",
	"menu.promotions.globals": "Global Types",
	"menu.promotions.brand-outlet": "By Brand/Outlet",
	"menu.payment-types": "Payment Types",
	"menu.payment-types.globals": "Global Types",
	"menu.payment-types.brand-outlet": "By Brand/Outlet",
	"menu.payment-types.payment-reorder": "Reorder Payment Types",
	"menu.pos-discounts": "Discounts",
	"menu.digital-signage": "Digital Signage",
	"menu.Reports": "Reports",
	"menu.Reports.Z-Reports": "Z Reports",
	"menu.Sales": "Sales",
	"menu.Sales.Daily Sales Browser": "Daily Sales Browser",
	"menu.Sales.Transactions": "Transactions",
	"salesdata.transactions.pageDescription": "Browse, search, and audit sales transactions, payment details, and receipts across your outlets and terminals.",
	"salesdata.transactions.selectPrompt": "Please select brand, outlet, and accounting date.",
	"menu.Sales.Cash Collections": "Cash Collections",
	"menu.Sales.Mark Cash Collections": "Mark Cash Collections",
	"menu.Sales.Settlements": "Settlements",
	"menu.Receipt Page": "Receipt Page",
	"menu.Reports.Export Raw Data": "Export Raw Data",
	"menu.Reports.Inventory Movement": "Inventory Movement",
	"menu.Xero": "Accounting",
	"menu.Xero.callback": "Callback",
	"menu.Xero.consent": "Consent",
	"menu.Xero.linkage": "Linkage",
	"menu.Xero.Posting": "Posting",
	"menu.Xero.invoices": "Invoices",
	"menu.Xero.invoices.all-invoices": "All Invoices",
	"menu.Xero.invoices.working-invoices": "Working Invoices",
	"menu.Xero.invoices.unposted-invoices": "Failed Invoices",
	"menu.Xero.invoices.view-invoice": "uPOS Invoice",
	"menu.Xero.mapping": "Code Mapping",
	"menu.Xero.invoice-config": "Invoice Configuration",
	"menu.apikey": "API Keys",
	"menu.organization-structure": "Business Setup",
	"menu.organization-structure.brands": "Brands",
	"menu.organization-structure.outlets": "Outlets",
	"menu.organization-structure.terminals": "Terminals",
	"menu.organization-structure.suppliers": "Suppliers",
	"menu.staff": "Staff",
	"menu.Inventory": "Inventory",
	"menu.Inventory.Catalogue": "Catalogue",
	"menu.Inventory.Catalogue.Global": "Global",
	"menu.Inventory.Catalogue.Brand": "Brand",
	"menu.Inventory.master-stock-list": "Master Stock List",
	"menu.Inventory.Stocks": "Stocks",
	"menu.Inventory.Process Incoming-Stock": "Process Incoming-Stock",
	"menu.payment-type": "Payment Types",
	"menu.payment-types.By Brand/Outlet": "By Brand/Outlet",
	"menu.payment-types.Global Types": "Global Types",
	"menu.config.malls": "Malls",
	"menu.config.sectors": "Sectors",
	"menu.config.uom": "Inventory UOM",
	"menu.change-password": "Change Password",
	"menu.config": "Misc. Configurations",
	"menu.config.policy-group": "Policy Group",
	"menu.config.pos-versions": "uPOS Versions",
	"menu.config.staff": "Staff",
	"menu.config.staff-v2": "Staff (v2)",
	"menu.config.access-control": "Access Control",
	"menu.config.application-settings": "Application Settings",
	"menu.config.pos-languages": "POS Languages",
	"menu.config.pos-languages.global-pos-languages": "Global Languages",
	"menu.config.pos-languages.brand-outlet-pos-languages": "By Brand/Outlet",
	"menu.config.sales-groups": "Sales Groups",
	"menu.config.sales-groups.global-sales-groups": "Global Sales Groups",
	"menu.config.sales-groups.brand-outlet-sales-groups": "By Brand/Outlet",
	"menu.config.appsetting": "App Settings",
	"menu.welcome": "Welcome",
	"menu.qrcode": "QR Code trial",
	"menu.more-blocks": "More Blocks",
	"menu.home": "Home",
	"menu.admin": "admin",
	"menu.login": "Login",
	"menu.register": "Register",
	"menu.register.result": "Register Result",
	"menu.exception.403": "403",
	"menu.exception.404": "404",
	"menu.exception.500": "500",
	"menu.form": "Form",
	"menu.profile": "Profile",
	"menu.profile.basic": "Basic Profile",
	"menu.profile.advanced": "Advanced Profile",
	"menu.result": "Result",
	"menu.result.success": "Success",
	"menu.result.fail": "Fail",
	"menu.exception": "Exception",
	"menu.exception.not-permission": "403",
	"menu.exception.not-find": "404",
	"menu.exception.server-error": "500",
	"menu.exception.trigger": "Trigger",
	"menu.account": "Account",
	"menu.account.password": "Change Password",
	"menu.account.center": "Account Center",
	"menu.account.settings": "Account Settings",
	"menu.account.trigger": "Trigger Error",
	"menu.account.logout": "Logout",
	"menu.editor": "Graphic Editor",
	"menu.editor.flow": "Flow Editor",
	"menu.editor.mind": "Mind Editor",
	"menu.editor.koni": "Koni Editor",
	"menu.MallUpload": "Data Upload",
	"menu.MallUpload.upload-config": "Upload Configuration",
	"menu.MallUpload.file": "Upload Files",
	"menu.MallUpload.file.all-files": "All Files",
	"menu.MallUpload.file.unposted-files": "Failed Files",
	"menu.logs": "Logs",
	"menu.integration": "Integrations",
	"menu.delivery-platforms": "Delivery Platforms",
	"menu.delivery-platforms.delivery-order": "Delivery Orders",
	"menu.delivery-platforms.delivery-config": "Delivery Configuration",
	"menu.setup": "Setup",
	"menu.user-management": "User Management",
	"menu.user-management.users": "Users",
	"menu.user-management.roles": "Roles",
	"menu.windows-pos": "Windows POS",
	"menu.windows-pos.pos-versions": "uPOS Versions",
	"menu.windows-pos.language-keys": "Language Keys",
	"menu.finance": "Finance",
	"menu.sales-operations": "Sales",
	"menu.support-operations": "Support",
	"menu.inventory-operations": "Inventory",
};
